export const Order = (json: IOrder): IOrderModel => {
	const fromJSON = (itemJson: IOrder) => {
		const {
			client,
			started_at,
			ended_at,
			created_at,
			days_to_end,
			last_delivery_at,
			address,
			friendly_id,
			client_profile,
			days_count,
			days_left_count,
			diet,
			diet_id,
			first_diet_day,
			last_diet_day,
			next_delivery_date,
			last_delivery_date,
			address_id,
			...rest
		} = itemJson
		return {
			client: client ? clientFromJSON(client) : null,
			startedAt: started_at ? new Date(started_at) : null,
			endedAt: ended_at ? new Date(ended_at) : null,
			createdAt: created_at ? new Date(created_at) : null,
			daysToEnd: days_to_end,
			lastDeliveryAt: last_delivery_at ? new Date(last_delivery_at) : null,
			diet: diet ? Diet(diet) : null,
			dietID: diet_id,
			address: address ? ClientAddress(address) : null,
			friendlyID: friendly_id,
			clientProfile: client_profile ? ClientProfile(client_profile) : null,
			daysCount: days_count,
			daysLeftCount: days_left_count,
			firstDietDay: first_diet_day ? new Date(first_diet_day) : null,
			lastDietDay: last_diet_day ? new Date(last_diet_day) : null,
			nextDeliveryDate: next_delivery_date ? new Date(next_delivery_date) : null,
			lastDeliveryDate: last_delivery_date ? new Date(last_delivery_date) : null,
			addressID: address_id,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const OrderDayMeal = (json: IOrderDaysMealForm): IOrderDaysMealFormModel => {
	const fromJSON = (itemJson: IOrderDaysMealForm) => {
		const { meal_type, ...rest } = itemJson
		return {
			mealType: meal_type,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const orderDayMealToJSON = (obj: IOrderDaysMealFormModel): IOrderDaysMealForm => {
	const { mealType, sizeID, variantID, ...rest } = obj
	return {
		meal_type: mealType,
		size_id: sizeID,
		variant_id: variantID,
		...rest,
	}
}

export const OrderDayForm = (json: IOrderDayForm): IOrderDayFormModel => {
	const fromJSON = (itemJson: IOrderDayForm) => {
		const { meal_slots, ...rest } = itemJson
		return {
			mealSlots: meal_slots,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const orderDayFormToJSON = (obj: IOrderDayFormModel): IOrderDayForm => {
	const { mealSlots, ...rest } = obj
	return {
		meal_slots: mealSlots ? mealSlots.map(m => orderDayMealToJSON(m)) : [],
		...rest,
	}
}

export const orderToJSON = (obj: Partial<IOrderSendFormModel>): Partial<IOrderSendForm> => {
	const { addressID, dietID, clientID, dietOrderDays, ...rest } = obj
	return {
		address_id: addressID,
		diet_id: dietID,
		client_id: clientID,
		meal_kind: 'meal',
		diet_order_days: dietOrderDays ? dietOrderDays.map(day => orderDayFormToJSON(day)) : [],
		...rest,
	}
}
